var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "place_black_24dp 1",
    clipPath: "url(#clip0_3206_3310)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.99935 7.99992C7.26602 7.99992 6.66602 7.39992 6.66602 6.66658C6.66602 5.93325 7.26602 5.33325 7.99935 5.33325C8.73268 5.33325 9.33268 5.93325 9.33268 6.66658C9.33268 7.39992 8.73268 7.99992 7.99935 7.99992ZM11.9993 6.79992C11.9993 4.37992 10.2327 2.66659 7.99935 2.66659C5.76602 2.66659 3.99935 4.37992 3.99935 6.79992C3.99935 8.35992 5.29935 10.4266 7.99935 12.8933C10.6993 10.4266 11.9993 8.35992 11.9993 6.79992ZM7.99935 1.33325C10.7993 1.33325 13.3327 3.47992 13.3327 6.79992C13.3327 9.01325 11.5527 11.6333 7.99935 14.6666C4.44602 11.6333 2.66602 9.01325 2.66602 6.79992C2.66602 3.47992 5.19935 1.33325 7.99935 1.33325Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3206_3310"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.9b44c3c45e3dbe66ce68426f6e0ea641.svg";
export { ForwardRef as ReactComponent };